import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SigningPage } from './pages/SigningPage';
import { SuccessPage } from './pages/SuccessPage';
import { ExpiredPage } from './pages/ExpiredPage';
import { WelcomePage } from './pages/WelcomePage';
import './App.scss';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/sign/:sessionToken" element={<SigningPage />} />
          <Route path="/sign/:sessionToken/success" element={<SuccessPage />} />
          <Route path="/expired" element={<ExpiredPage />} />
          <Route path="*" element={<Navigate to="/expired" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
